import { api } from "./api";

// Thin API layer for the course-workbook feature. Kept as tiny wrappers so
// pages don't sprinkle endpoint strings across the codebase and switching
// to a fetch client (or adding a global loading indicator) later is a
// one-file change.

export function playbookPdfUrl() {
  // The endpoint is Bearer-protected, but the browser send the same JWT
  // cookie automatically when opened in a same-origin iframe / tab. The FE
  // hits it via axios (with credentials) and turns the blob into a download.
  return "/workbook/playbook.pdf";
}

export async function downloadPlaybookPdf() {
  const r = await api.get(playbookPdfUrl(), { responseType: "blob" });
  const blob = new Blob([r.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "CPG-Founders-Playbook.pdf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function fetchDigestPreview() {
  const r = await api.get("/progress/decisions/digest-preview");
  return r.data;
}

export async function fetchWorkbookModules() {
  const r = await api.get("/workbook/modules");
  return r.data;
}

export async function fetchWorksheetSummaries(params = {}) {
  const r = await api.get("/worksheets", { params });
  return r.data;
}

export async function fetchWorksheet(worksheetId) {
  const r = await api.get(`/worksheets/${encodeURIComponent(worksheetId)}`);
  return r.data;
}

export async function fetchResponse(worksheetId) {
  const r = await api.get(`/responses/${encodeURIComponent(worksheetId)}`);
  return r.data;
}

// Partial PUT — pass only the changed answer keys (or a decision patch).
// The backend deep-merges; DO NOT send the whole `answers` blob every call.
export async function putResponse(worksheetId, patch) {
  const r = await api.put(`/responses/${encodeURIComponent(worksheetId)}`, patch);
  return r.data;
}

export async function deleteResponse(worksheetId) {
  const r = await api.delete(`/responses/${encodeURIComponent(worksheetId)}`);
  return r.data;
}

export async function submitResponse(worksheetId) {
  // Returns 422 with {message, gate_complete, completion_pct, required_missing}
  // when the response fails the submit gate. Caller should surface the message.
  const r = await api.post(`/responses/${encodeURIComponent(worksheetId)}/submit`);
  return r.data;
}

export async function fetchProgress() {
  const r = await api.get("/progress");
  return r.data;
}

export async function fetchDecisions() {
  const r = await api.get("/progress/decisions");
  return r.data;
}
